import {Layout} from 'components/layout';
import React, {useState, useEffect} from 'react';
import {Button} from '../primitives/button/button';
import {cn} from 'lib/utils';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../dialog/dialog';
import {Input} from '../primitives/imput/input';
import {Checkbox} from '../primitives/checkbox/checkbox';
import {FinishingDotItem} from '../finishing-dot-item/finishing-dot-item';
import {IMaskInput} from "react-imask";
import {useSendForm} from "../../../lib/hooks/use-send-form";

import {useConsentStore} from "../../../lib/store/consent-store";

export const Finishing = () => {
  const [currentTab, setCurrentTab] = useState({
    value: 'without',
    label: 'БЕЗ ОТДЕЛКИ',
  });

  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false)
  const [fieldsError, setFieldsError] = useState(false)

  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    text: currentTab.label
  })

  useEffect(() => {
    setFieldsError(false)
  }, [formData])

  useEffect(() => {
    setTermsError(false)
  }, [termsChecked]);

  useEffect(() => {
    setFormData({...formData, text: currentTab.label})
    setSuccess(false)
  }, [currentTab]);

  const handleInputChange = (value: string, name: string) => {
    setFormData({...formData, [name]: value})
  }

  const validateFormAndSend = (celtype: string) => {
    if (formData.name === '' || formData.phone === '') {
      setFieldsError(true)

      return
    }

    if (formData.phone !== '') {
      const cleaned = formData.phone.replace(/\D/g, '');
      const isDigitsOnly = /^\d+$/.test(cleaned);
      const isValidLength = cleaned.length >= 10 && cleaned.length <= 15;

      if (isDigitsOnly && isValidLength) {

      } else {
        setFieldsError(true)
        return
      }
    }

    if (!termsChecked) {
      setTermsError(true)
      return
    }

    sendForm(formData, celtype, () => {
      setSuccess(true)
    })
  }

  const {sendForm, isPending, error} = useSendForm()

  const tabsList = [
    {value: 'without', label: 'БЕЗ ОТДЕЛКИ'},
    {value: 'whitebox', label: 'ОТДЕЛКА WHITE BOX'},
    {value: 'clean', label: 'ЧИСТОВАЯ ОТДЕЛКА'},
  ];

  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  return (
    <section id='finishing' className="mt-[100px] font-open-sans screen-1150:mt-5">
      <Layout.Container>
        <div className="px-[33px] pb-10">
          <h3 className="uppercase font-bold text-center text-[32px] text-plt-black screen-700:text-lg">
            КВАРТИРЫ С ОТДЕЛКОЙ И БЕЗ
          </h3>
          <div
            className="grid grid-cols-3 gap-5 mt-[64px] max-w-[1120px] mx-auto screen-850:grid-cols-1 screen-850:gap-2 screen-850:mt-6">
            {tabsList.map((tab) => (
              <Button
                key={tab.value}
                onClick={() => setCurrentTab(tab)}
                className={cn(
                  'bg-plt-white border-2 border-plt-secondary rounded-[15px] h-[60px] text-plt-black font-bold text-xl',
                  currentTab.value === tab.value &&
                  'bg-plt-secondary text-plt-white'
                )}
              >
                {tab.label}
              </Button>
            ))}
          </div>
          <div className="mt-10 flex items-center gap-20 screen-1150:flex-col-reverse screen-1150:gap-6">
            {currentTab.value === 'whitebox' && (
              <>
                <Dialog>
                  <DialogTrigger asChild>
                    <Button
                      className="rounded-[12px] font-semibold h-11 w-[266px] hidden screen-1150:flex screen-600:w-full">
                      Узнать подробнее
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="bg-plt-white border-none w-[345px] p-[50px] rounded-[20px]">
                    <DialogHeader>
                      <DialogTitle className="text-center text-plt-secondary">
                        Узнать подробнее
                        <br/> об отделке WHITE BOX
                      </DialogTitle>
                    </DialogHeader>
                    <div className="grid gap-1 mt-4">
                      <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                             placeholder="Ваше имя"/>
                      <IMaskInput value={formData.phone} onAccept={value => handleInputChange(value, 'phone')}
                                  mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
                        'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                        'rounded-[5px]'
                      )}/>
                      <Button disabled={isPending} onClick={() => validateFormAndSend('getRenovationWhitebox')}>Узнать
                        подробнее</Button>
                      {termsError &&
                          <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных
                            данных</p>}
                      {fieldsError &&
                          <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
                    </div>
                    {success &&
                        <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                          успешно
                          отправлена, спасибо!</p>}
                    <div className="flex items-center gap-2 mt-4">
                      <Checkbox checked={termsChecked} onCheckedChange={checked => setTermsChecked(checked === true)}
                                className="rounded-[1px] border-[#D3D3D3]"/>
                      <label className="text-xs text-[#989898] text-[10px] tracking-[-3%] leading-[120%]">
                        Нажимая кнопку «Узнать подробнее», вы даете согласие на
                        обработку персональных данных и соглашаетесь с политикой
                        конфиденциальности
                      </label>
                    </div>
                    <div className="flex items-center gap-2 mt-4">
                      <Checkbox checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                                className="rounded-[1px] border-[#D3D3D3] shrink-0"/>
                      <label className="text-xs text-[#989898]">
                        Я ознакомлен (-на) с правилами обработки куки
                      </label>
                    </div>
                  </DialogContent>
                </Dialog>
                <div className="relative shrink-0">
                  <img
                    className="h-[376px] w-[733px] object-cover rounded-[40px] screen-850:rounded-[5px] screen-700:w-full screen-700:h-full"
                    src="/assets/images/png/finishing-white-box.png"
                    alt=""
                  />
                  <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-full">
                    <FinishingDotItem
                      className="right-[40%] top-[10%]"
                      label="Выравнивание потолков"
                    />
                    <FinishingDotItem
                      className="right-[40%] bottom-[10%]"
                      label="Стяжка на полу"
                    />
                    <FinishingDotItem
                      align="left"
                      className="right-[20%] bottom-[5%]"
                      label="Горизонтальная разводка отопления"
                    />
                    <FinishingDotItem
                      className="left-[44%] top-[15%]"
                      label="Разводка электрики"
                    />
                    <FinishingDotItem
                      className="left-[34%] top-[50%]"
                      label="Выравнивание стен"
                    />
                  </div>
                </div>
                <div>
                  <h4
                    className="uppercase font-bold text-2xl leading-[120%] screen-1150:text-center screen-1150:normal-case screen-1150:text-plt-secondary">
                    Предчистовая отделка WHITE BOX
                  </h4>
                  <p
                    className="font-semibold text-xl leading-[120%] text-plt-black mt-8 screen-1150:mt-4 screen-1150:text-sm screen-1150:text-center screen-1150:font-normal">
                    Вам не придется производить грязные и пыльные
                    подготовительные работы. Приобретая отделку WHITE BOX, Вы
                    получаете белый холст, готовый к самому интересному этапу
                    ремонта – созданию Вашего неповторимого интерьера.
                  </p>
                  <Dialog>
                    <DialogTrigger asChild>
                      <Button className="rounded-[12px] font-semibold h-10 w-[266px] mt-16 screen-1150:hidden">
                        Узнать подробнее
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="bg-plt-white border-none w-[345px] p-[50px] rounded-[20px]">
                      <DialogHeader>
                        <DialogTitle className="text-center text-plt-secondary">
                          Узнать подробнее
                          <br/> об отделке WHITE BOX
                        </DialogTitle>
                      </DialogHeader>
                      <div className="grid gap-1 mt-4">
                        <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                               placeholder="Ваше имя"/>
                        <IMaskInput value={formData.phone} onAccept={value => handleInputChange(value, 'phone')}
                                    mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
                          'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                          'rounded-[5px]'
                        )}/>
                        <Button disabled={isPending} onClick={() => validateFormAndSend('getRenovationWhitebox')}>Узнать
                          подробнее</Button>
                        {termsError &&
                            <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных
                              данных</p>}
                        {fieldsError &&
                            <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
                      </div>
                      {success &&
                          <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                            успешно
                            отправлена, спасибо!</p>}
                      <div className="flex items-center gap-2 mt-4">
                        <Checkbox checked={termsChecked} onCheckedChange={checked => setTermsChecked(checked === true)}
                                  className="rounded-[1px] border-[#D3D3D3]"/>
                        <label className="text-xs text-[#989898] text-[10px] tracking-[-3%] leading-[120%]">
                          Нажимая кнопку «Узнать подробнее», вы даете согласие
                          на обработку персональных данных и соглашаетесь с
                          политикой конфиденциальности
                        </label>
                      </div>
                      <div className="flex items-center gap-2 mt-4">
                        <Checkbox checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                                  className="rounded-[1px] border-[#D3D3D3]"/>
                        <label className="text-xs text-[#989898]">
                          Я ознакомлен (-на) с правилами обработки куки
                        </label>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </>
            )}
            {currentTab.value === 'without' && (
              <>
                <Dialog>
                  <DialogTrigger asChild>
                    <Button
                      className="rounded-[12px] font-semibold h-10 w-[266px] hidden screen-1150:flex screen-600:w-full">
                      Узнать подробнее
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="bg-plt-white border-none w-[345px] p-[50px] rounded-[20px]">
                    <DialogHeader>
                      <DialogTitle className="text-center text-plt-secondary font-bold text-xl">
                        Узнать подробнее
                        <br/> о черновой отделке
                      </DialogTitle>
                    </DialogHeader>
                    <div className="grid gap-1 mt-4">
                      <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                             placeholder="Ваше имя"/>
                      <IMaskInput value={formData.phone} onAccept={value => handleInputChange(value, 'phone')}
                                  mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
                        'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                        'rounded-[5px]'
                      )}/>
                      <Button disabled={isPending} onClick={() => validateFormAndSend('getRenovationNone')}>Узнать
                        подробнее</Button>
                      {termsError &&
                          <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных
                            данных</p>}
                      {fieldsError &&
                          <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
                    </div>
                    {success &&
                        <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                          успешно
                          отправлена, спасибо!</p>}
                    <div className="flex items-center gap-2 mt-4">
                      <Checkbox checked={termsChecked} onCheckedChange={checked => setTermsChecked(checked === true)}
                                className="rounded-[1px] border-[#D3D3D3]"/>
                      <label className="text-xs text-[#989898] text-[10px] tracking-[-3%] leading-[120%] ">
                        Нажимая кнопку «Узнать подробнее», вы даете согласие на
                        обработку персональных данных и соглашаетесь с политикой
                        конфиденциальности
                      </label>
                    </div>
                    <div className="flex items-center gap-2 mt-4">
                      <Checkbox checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                                className="rounded-[1px] border-[#D3D3D3]"/>
                      <label className="text-xs text-[#989898]">
                        Я ознакомлен (-на) с правилами обработки куки
                      </label>
                    </div>
                  </DialogContent>
                </Dialog>
                <div className="shrink-0">
                  <img
                    className="h-[376px] w-[733px] object-cover rounded-[40px] screen-850:rounded-[5px] screen-700:w-full screen-700:h-full"
                    src="/assets/images/png/finishing-without.png"
                    alt=""
                  />
                </div>
                <div>
                  <h4
                    className="uppercase font-bold text-2xl leading-[120%] screen-1150:text-center screen-1150:normal-case screen-1150:text-plt-secondary">
                    Без отделки
                  </h4>
                  <p
                    className="font-semibold text-xl leading-[120%] text-plt-black mt-8 screen-1150:mt-4 screen-1150:text-sm screen-1150:text-center screen-1150:font-normal">
                    Данный вариант отлично подойдет для тех, кому важно
                    участвовать в каждом этапе ремонтных работ, контролировать
                    все процессы и иметь возможность вносить корректировки во
                    время черновых работ, например, изменить разводку электрики.
                  </p>
                  <Dialog>
                    <DialogTrigger asChild>
                      <Button className="rounded-[12px] font-semibold h-10 w-[266px] mt-16 screen-1150:hidden">
                        Узнать подробнее
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="bg-plt-white border-none w-[345px] p-[50px] rounded-[20px]">
                      <DialogHeader>
                        <DialogTitle className="text-center text-plt-secondary font-bold text-xl">
                          Узнать подробнее
                          <br/> о черновой отделке
                        </DialogTitle>
                      </DialogHeader>
                      <div className="grid gap-1 mt-4">
                        <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                               placeholder="Ваше имя"/>
                        <IMaskInput value={formData.phone} onAccept={value => handleInputChange(value, 'phone')}
                                    mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
                          'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                          'rounded-[5px]'
                        )}/>
                        <Button disabled={isPending} onClick={() => validateFormAndSend('getRenovationNone')}>Узнать
                          подробнее</Button>
                        {termsError &&
                            <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных
                              данных</p>}
                        {fieldsError &&
                            <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
                      </div>
                      {success &&
                          <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                            успешно
                            отправлена, спасибо!</p>}
                      <div className="flex items-center gap-2 mt-4">
                        <Checkbox checked={termsChecked} onCheckedChange={checked => setTermsChecked(checked === true)}
                                  className="rounded-[1px] border-[#D3D3D3]"/>
                        <label className="text-xs text-[#989898] text-[10px] tracking-[-3%] leading-[120%]">
                          Нажимая кнопку «Узнать подробнее», вы даете согласие
                          на обработку персональных данных и соглашаетесь с
                          политикой конфиденциальности
                        </label>
                      </div>
                      <div className="flex items-center gap-2 mt-4">
                        <Checkbox checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                                  className="rounded-[1px] border-[#D3D3D3]"/>
                        <label className="text-xs text-[#989898]">
                          Я ознакомлен (-на) с правилами обработки куки
                        </label>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </>
            )}
            {currentTab.value === 'clean' && (
              <>
                <Dialog>
                  <DialogTrigger asChild>
                    <Button
                      className="rounded-[12px] font-semibold h-10 w-[266px] hidden screen-1150:flex screen-600:w-full">
                      Узнать подробнее
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="bg-plt-white border-none w-[345px] p-[50px] rounded-[20px]">
                    <DialogHeader>
                      <DialogTitle className="text-center text-plt-secondary font-bold text-xl">
                        Узнать подробнее
                        <br/> о чистовой отделке
                      </DialogTitle>
                    </DialogHeader>
                    <div className="grid gap-1 mt-4">
                      <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                             placeholder="Ваше имя"/>
                      <IMaskInput value={formData.phone} onAccept={value => handleInputChange(value, 'phone')}
                                  mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
                        'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                        'rounded-[5px]'
                      )}/>
                      <Button disabled={isPending} onClick={() => validateFormAndSend('getRenovationFull')}>Узнать
                        подробнее</Button>
                      {termsError &&
                          <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных
                            данных</p>}
                      {fieldsError &&
                          <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
                    </div>
                    {success &&
                        <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                          успешно
                          отправлена, спасибо!</p>}
                    <div className="flex items-center gap-2 mt-4">
                      <Checkbox checked={termsChecked} onCheckedChange={checked => setTermsChecked(checked === true)}
                                className="rounded-[1px] border-[#D3D3D3]"/>
                      <label className="text-xs text-[#989898] text-[10px] tracking-[-3%] leading-[120%]">
                        Нажимая кнопку «Узнать подробнее», вы даете согласие на
                        обработку персональных данных и соглашаетесь с политикой
                        конфиденциальности
                      </label>
                    </div>
                    <div className="flex items-center gap-2 mt-4">
                      <Checkbox checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                                className="rounded-[1px] border-[#D3D3D3]"/>
                      <label className="text-xs text-[#989898]">
                        Я ознакомлен (-на) с правилами обработки куки
                      </label>
                    </div>
                  </DialogContent>
                </Dialog>
                <div className="relative shrink-0">
                  <img
                    className="h-[376px] w-[733px] object-cover rounded-[40px] screen-850:rounded-[5px] screen-700:w-full screen-700:h-full"
                    src="/assets/images/png/finishing-clean.png"
                    alt="чистовая отделка"
                  />
                  <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-full">
                    <FinishingDotItem
                      className="left-[43%] bottom-[12%]"
                      label="Вывод под электроплиту"
                    />
                    <FinishingDotItem
                      className="left-[38%] top-[30%]"
                      label="Обои под покраску"
                    />
                    <FinishingDotItem
                      className="left-[9%] bottom-[27%]"
                      label="Установка розеток и выключателей"
                    />
                    <FinishingDotItem
                      className="right-[43%] bottom-[37%]"
                      label="Межкомнатные и входные двери"
                    />
                    <FinishingDotItem
                      align="left"
                      className="right-[30%] top-[10%]"
                      label="Установка закладных под светильники"
                    />
                    <FinishingDotItem
                      className="left-[30%] top-[5%]"
                      label="Натяжные потолки"
                    />
                    <FinishingDotItem
                      className="right-[20%] bottom-[5%]"
                      label="ПВХ плинтуса"
                    />
                    <FinishingDotItem
                      className="right-[40%] bottom-[5%]"
                      label="Ламинат"
                    />
                  </div>
                </div>
                <div>
                  <h4
                    className="uppercase font-bold text-2xl leading-[120%] screen-1150:text-center screen-1150:normal-case screen-1150:text-plt-secondary">
                    Чистовая отделка
                  </h4>
                  <p
                    className="font-semibold text-xl leading-[120%] text-plt-black mt-8 screen-1150:mt-4 screen-1150:text-sm screen-1150:text-center screen-1150:font-normal">
                    Главное преимущество покупки квартиры с готовым ремонтом –
                    возможность заселения сразу же после получения ключей. Это
                    идеальный вариант для тех, кто не готов тратить время на
                    ремонт, для новоселья нужно лишь завести мебель и технику.
                  </p>
                  <Dialog>
                    <DialogTrigger asChild>
                      <Button className="rounded-[12px] font-semibold h-10 w-[266px] mt-16 screen-1150:hidden">
                        Узнать подробнее
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="bg-plt-white border-none w-[345px] p-[50px] rounded-[20px]">
                      <DialogHeader>
                        <DialogTitle className="text-center text-plt-secondary font-bold text-xl">
                          Узнать подробнее
                          <br/> о чистовой отделке
                        </DialogTitle>
                      </DialogHeader>
                      <div className="grid gap-1 mt-4">
                        <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                               placeholder="Ваше имя"/>
                        <IMaskInput value={formData.phone} onAccept={value => handleInputChange(value, 'phone')}
                                    mask={'+7 (000) 000-00-00'} placeholder={'Ваш телефон'} className={cn(
                          'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                          'rounded-[5px]'
                        )}/>
                        <Button disabled={isPending} onClick={() => validateFormAndSend('getRenovationFull')}>Узнать
                          подробнее</Button>
                        {termsError &&
                            <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных
                              данных</p>}
                        {fieldsError &&
                            <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
                      </div>
                      {success &&
                          <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                            успешно
                            отправлена, спасибо!</p>}
                      <div className="flex items-center gap-2 mt-4">
                        <Checkbox checked={termsChecked} onCheckedChange={checked => setTermsChecked(checked === true)}
                                  className="rounded-[1px] border-[#D3D3D3]"/>
                        <label className="text-xs text-[#989898] text-[10px] tracking-[-3%] leading-[120%]">
                          Нажимая кнопку «Узнать подробнее», вы даете согласие
                          на обработку персональных данных и соглашаетесь с
                          политикой конфиденциальности
                        </label>
                      </div>
                      <div className="flex items-center gap-2 mt-4">
                        <Checkbox checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                                  className="rounded-[1px] border-[#D3D3D3]"/>
                        <label className="text-xs text-[#989898]">
                          Я ознакомлен (-на) с правилами обработки куки
                        </label>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </>
            )}
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
